import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const AcorddionContainer = styled.div`
  border: 1px solid #000eff;
  border-radius: 4px;
  width: 520px;
  padding: 13px 25px;

  & + div {
    margin-top: 16px;
  }

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const AccordionTitle = styled.span`
  color: #000eff;
  font-size: 1rem;
  line-height: 1.2rem;
  font-weight: 500;
  max-width: 450px;
  font-family: 'Mangueira', sans-serif;
`;

export const AccordionBody = styled.div`
  margin-top: 0;
  color: #000eff;
  font-size: 14px;
  height: 0;
  transition: all 0.2s;
  overflow: hidden;
  font-size: 0.9rem;

  .span-wrap {
    display: flex;
    flex-direction: column;
    span {
      display: inline-block;
    }
  }

  button {
    background: transparent;
    border: none;
    color: #000eff;
    text-decoration: underline;
    outline: unset !important;
  }

  ${({ showBody }) =>
    showBody &&
    css`
      height: 100%;
      margin-top: 16px;
    `}
`;

export const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
`;

export const FaqNotFound = styled.span``;
